import { isEn } from "i18next-config";

export class ActionIdentifierDto {
  static fromApi(data) {
    return {
      id: data.id,
      name:
        typeof data.description === "string"
          ? data.description
          : isEn
            ? data.description?.en
            : data.description?.gr,
      composition: data.composition,
      value: data.agroMeta?.value ?? data.agroMeta?.["values:"],
      operationsIds: data.operationsIds,
      taskIds: data.tasksIds,
    };
  }
}

export class ActionIdentifiersListDto {
  static fromApi(data) {
    const results = data.results;

    const dataArray = results.map(ActionIdentifierDto.fromApi);
    return dataArray;
  }
}
